export const roleConstants = {
    ROLE_SUCCESS: 'ROLE_SUCCESS',
}